export enum ThresholdEnum {
  CLIENTS = 1,
  MANUFACTURES = 2,
}

interface IThresholdValues {
  title: string
  description: string
}

export const ThresholdValues: Record<ThresholdEnum, IThresholdValues> = {
  [ThresholdEnum.CLIENTS]: {
    title: 'Morosidad',
    description:
      'Esta función asigna un código de color en el reporte de transacciones del cliente según los días transcurridos desde la emisión de la venta, lo que facilita identificar visualmente posibles retrasos en el pago.',
  },
  [ThresholdEnum.MANUFACTURES]: {
    title: 'Tiempo de espera',
    description:
      'Esta función asigna un código de color a las manufacturas en la aplicación móvil de Kolo en función del tiempo transcurrido, en minutos, desde su creación hasta el momento actual. Los valores mínimo y máximo están expresados en minutos.',
  },
}
